<div class="plate-preview" [class.compact-on-mobile]="compactOnMobile" [attr.aria-label]="ariaLabel">
  <div class="plate-main">
    <div class="plate-cell plate-value">{{ digits || '-' }}</div>
    <div class="plate-cell plate-value plate-letters-value" [class.plate-ar]="hasArabicPlateLetters(originalLetters)"
      [class.plate-letters-rtl]="hasArabicPlateLetters(originalLetters)">
      @if (originalLetters.length) {
        @for (letter of originalLetters; track $index) {
          <span [attr.dir]="isArabicLetter(letter) ? 'rtl' : 'ltr'">{{ letter }}</span>
        }
      } @else {
        <span>-</span>
      }
    </div>
    <div class="plate-cell plate-value plate-ar">{{ mappedDigits || '-' }}</div>
    <div class="plate-cell plate-value plate-letters-value plate-letters-mapped" [class.plate-ar]="hasArabicPlateLetters(mappedLetters)"
      [class.plate-letters-mapped-reversed]="hasArabicPlateLetters(originalLetters)">
      @if (mappedLetters.length) {
        @for (letter of mappedLetters; track $index) {
          <span [attr.dir]="isArabicLetter(letter) ? 'rtl' : 'ltr'">{{ letter }}</span>
        }
      } @else {
        <span>-</span>
      }
    </div>
  </div>
  <div class="plate-country">
    <img [src]="countryLogo" [alt]="countryAlt" />
    <div>
      @for (char of countryCode.split(''); track $index) {
        <span>{{ char }}</span>
      }
    </div>
  </div>
</div>
